@if (active) {
	<img
		src="/assets/orca/searchFilter/filter-off.svg"
		alt="Reset Filter"
		ngbTooltip="{{ 'global.reset-filter' | translate }}"
		style="height: 1.5rem; width: 1.5rem"
		class="cursor-pointer"
		(click)="resetFilter.emit()" />
}
@if (!active) {
	<img src="/assets/orca/searchFilter/filter.svg" alt="Inactive Filter" style="height: 1.5rem; width: 1.5rem" />
}
